import { injectable } from "tsyringe";

@injectable()
export class TopLevelDomainExtractor {
  public static extract(hostname): string {
    const parts = hostname.split(".");

    if (parts.length < 2) {
      return hostname;
    }

    let topLevelDomain = `.${parts[parts.length - 2]}.${
      parts[parts.length - 1]
    }`;

    // These exceptions require a third part for a valid cookie domain. This isn't
    // a definitive list but rather the most likely domains on which Fandom would
    // host a site.
    const exceptions = [".co.jp", ".co.nz", ".co.uk"];

    if (exceptions.indexOf(topLevelDomain) >= 0) {
      topLevelDomain = `.${parts[parts.length - 3]}${topLevelDomain}`;
    }

    return topLevelDomain;
  }
}
